import {useEffect, useMemo} from "react";
import {debounce} from "lodash";

export function useDebounce(functionToDelay, wait, flushOnUnmount, dependencies=[]) {
    const debouncedFunction = useMemo(
        ()=>debounce(functionToDelay, wait)
        , dependencies);

    useEffect(()=>{
        return () => {
            //When component is unmounting...
            if (flushOnUnmount) {
                debouncedFunction.flush();  //i.e. If pending debounce, trigger it now
            } else {
                debouncedFunction.cancel(); //i.e. If pending debounce, cancel it
            }
        }
    }, dependencies);

    return debouncedFunction;

}
